export class BaseEntity {
  id?: string | number;
  date_created?: string | Date | null;
  date_modified?: string | Date | null;
  created_by_id?: string | null;
  modified_by_id?: string | null;
}

export class DictEntity {
  code: string = '';
  name: string = '';
}

export class GraphicalDictEntity extends DictEntity {
    background: string = '#CCCCCC';
    text_color: string = '#444444';
}

// Универсальный дженерик тип для результата запроса
export interface IResponseResult<T> {
  data: T | null;
  message?: string;
}
